import { Injectable } from '@angular/core';

@Injectable()
export class CommonUtils {

    public isNullOrUndefined(item: any): boolean {
        return item === null || item === undefined;
    }

    public isEmpty(item: string): boolean {
        return this.isNullOrUndefined(item) || item.trim().length === 0;
    }

    public toInt(item: string): number {
        return this.isEmpty(item) ? undefined : parseInt(item, 10);
    }

    public isSorted(array: number[]): boolean {
        const limit = array.length - 1;
        return array.every((_: any, i: number) => (i < limit ? array[i] <= array[i + 1] : true));
    }
}
